/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Cupping_TermsInputs */

const en_service_type_cupping_terms = /** @type {(inputs: Service_Type_Cupping_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cupping, vacuum cups`)
};

const pl_service_type_cupping_terms = /** @type {(inputs: Service_Type_Cupping_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bańka chińska, masaż bańką, bańki próżniowe, cupping`)
};

/**
* | output |
* | --- |
* | "cupping, vacuum cups" |
*
* @param {Service_Type_Cupping_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_cupping_terms = /** @type {((inputs?: Service_Type_Cupping_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Cupping_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_cupping_terms(inputs)
	return en_service_type_cupping_terms(inputs)
});